// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.billing-icon-tile[data-v-3cda0552] {
    align-items: center;
    border-radius: 8px;
    display: inline-flex;
    flex: 0 0 auto;
    height: 44px;
    justify-content: center;
    width: 44px;
}
.billing-icon-tile--blue[data-v-3cda0552] {
    background: rgba(60, 100, 244, 0.18);
    color: #4d8dff;
}
.billing-icon-tile--cyan[data-v-3cda0552] {
    background: rgba(1, 154, 226, 0.18);
    color: #37b7f4;
}
.billing-icon-tile--green[data-v-3cda0552] {
    background: rgba(75, 200, 167, 0.18);
    color: #69d9b8;
}
.billing-icon-tile--orange[data-v-3cda0552] {
    background: rgba(243, 165, 95, 0.2);
    color: #f3a55f;
}
.billing-icon-tile--purple[data-v-3cda0552] {
    background: rgba(137, 99, 251, 0.2);
    color: #9c78ff;
}
`, "",{"version":3,"sources":["webpack://./portal/static/components/BillingAccounts/Shared/BillingIconTile.vue"],"names":[],"mappings":";AA4BA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,WAAW;AACf;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB","sourcesContent":["<template>\n    <span class=\"billing-icon-tile\" :class=\"toneClass\">\n        <v-icon size=\"24\">{{ icon }}</v-icon>\n    </span>\n</template>\n\n<script>\nexport default {\n    name: 'BillingIconTile',\n    props: {\n        icon: {\n            type: String,\n            default: '$vuetify.icons.info',\n        },\n        tone: {\n            type: String,\n            default: 'blue',\n        },\n    },\n    computed: {\n        toneClass() {\n            return `billing-icon-tile--${this.tone}`;\n        },\n    },\n};\n</script>\n\n<style scoped>\n.billing-icon-tile {\n    align-items: center;\n    border-radius: 8px;\n    display: inline-flex;\n    flex: 0 0 auto;\n    height: 44px;\n    justify-content: center;\n    width: 44px;\n}\n\n.billing-icon-tile--blue {\n    background: rgba(60, 100, 244, 0.18);\n    color: #4d8dff;\n}\n\n.billing-icon-tile--cyan {\n    background: rgba(1, 154, 226, 0.18);\n    color: #37b7f4;\n}\n\n.billing-icon-tile--green {\n    background: rgba(75, 200, 167, 0.18);\n    color: #69d9b8;\n}\n\n.billing-icon-tile--orange {\n    background: rgba(243, 165, 95, 0.2);\n    color: #f3a55f;\n}\n\n.billing-icon-tile--purple {\n    background: rgba(137, 99, 251, 0.2);\n    color: #9c78ff;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
